// extracted by mini-css-extract-plugin
export default {"select":"select_select","inputError":"select_inputError"};